export const DataLoader = {
    wrapper: {
        justifyContent: 'flex-start',
    },
};
